<mat-dialog-content>
  <lemon-dialog-header> Tilitapahtuman raakadata </lemon-dialog-header>

  <h3>Lemon Treen versio</h3>
  <div style="padding-left: 3em; padding-right: 3em" [innerHTML]="filteredData | ljson"></div>

  <h3 style="margin-top: 1em">Lisätiedot</h3>
  <pre style="padding-left: 3em; padding-right: 3em">{{ lisatiedotObservable | async | json }}</pre>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <div style="width: 100%; padding-bottom: 1em">
    <form novalidate>
      <mat-form-field>
        <mat-label>Korjaa viitenumero</mat-label>
        <input type="text" [formField]="lomake.viitenumero" matInput />
        <mat-hint>Täytä vain jos viitenumero on virheellinen tai se puuttuu.</mat-hint>
        @if (naytaVirhe(lomake.viitenumero, 'required')) {
          <mat-error> Viitenumero puuttuu </mat-error>
        }
        @if (naytaVirhe(lomake.viitenumero, 'viitenumero')) {
          <mat-error> Viitenumero on virheellinen </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
  <app-primary-button actionId="Tilitapahtuma: Peruuta" mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</app-primary-button>
  <app-secondary-button (click)="kohdistaTilitapahtuma()" actionId="Kohdista tilitapahtuma">Kohdista tilitapahtuma</app-secondary-button>
</mat-dialog-actions>
